import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const StoryCta = () => {
  const { t } = useTranslation();

  return (
    <section className="cta-section text-center text-white py-5" style={{ backgroundColor: "#D9D9D9" }}>
      <Container>
        <Row className="d-flex align-items-center text-center" style={{ paddingTop: "2rem" }}>
          <Col md={12}>
            <h2 className="mb-4 section-title">{t("cta-storybook")}</h2>
            <Button variant="light" className="rounded-pill px-4 py-2 jua" style={{ fontSize: "22px" }}>
              {t("cta-contact-us")}
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default StoryCta;
